import { AMapSandTable } from 'pano-amap';

export const stSceneAmap = new AMapSandTable();
export const stEnterAmap = new AMapSandTable();
